module.exports = ".ajout_espace {\n  margin-top: 70px; }\n\n.ajout-marge {\n  margin-left: 70px;\n  margin-right: 70px; }\n"